import image2 from '../../assets/images/products/HAMBURGUESA.jpg';
import noimage from '../../assets/images/no-imagen.svg';
import imagePerro from '../../assets/images/products/PERRO.jpg'
import imagePerroNY from '../../assets/images/products/PERRO-NY.jpg'
import image14 from '../../assets/images/products/PULLMAN-ENTERO.jpg';
import imageBolsaAlbahaca from '../../assets/images/products/BolsaBarraAlbahaca.jpg';
import imageBolsaNatural from '../../assets/images/products/BolsaBarrasNatural.jpg';
import imageBolsaNY from '../../assets/images/products/BolsaDePerro NY.jpg';
import imageBolsaViena from '../../assets/images/products/BolsadeViena.jpg';
import imageBaguette from '../../assets/images/products/Baguette.jpg';
import imageHogaza from '../../assets/images/products/Hogaza.jpg';
import imagePullmanTradicional from '../../assets/images/products/PullmanTradicional.jpg';


export const PRODUCTS = [    
    {
        name: "PAN HAMBURGUESA",
        id:1,
        quantity: 0,
        price: 35,
        images: image2,
        description: 
               `  "¿Estás buscando el pan perfecto para acompañar tu hamburguesa favorita? ¡Tenemos la solución para ti! Prueba nuestro delicioso pan de masa suave, especialmente diseñado para complementar el sabor de una jugosa hamburguesa.
                Este pan está horneado con los ingredientes de la más alta calidad, creando una textura suave y esponjosa que se deshace en tu boca con cada mordisco. Además, nuestra receta incluye un toque de ajonjolí en la corteza, lo que le da un sabor único y una apariencia atractiva.
                Nuestro pan de hamburguesa es la elección perfecta para cualquier ocasión, ya sea que estés disfrutando de una barbacoa con amigos, comiendo en tu restaurante de hamburguesas favorito o simplemente preparando una cena rápida en casa. El sabor y la textura de nuestro pan seguramente impresionarán a tus amigos y familiares, y se convertirá en un complemento esencial para tu hamburguesa.
                Así que, ¿por qué conformarte con cualquier pan para hamburguesas? Prueba nuestro pan de masa suave con ajonjolí y descubre una nueva dimensión de sabor en tu hamburguesa favorita. ¡Te garantizamos que no te arrepentirás!"`
           
    },    
    /*{
        name: "PAN BUNS",
        id:2,
        quantity: 0,
        price: 45,
        images: noimage,
        description: `
            ¡Prepárate para deleitar tus sentidos con nuestros deliciosos Pan Buns! Este pan redondo de
            masa suave es la adición perfecta para cualquier comida.
            Con su textura suave y esponjosa, nuestros Pan Buns son ideales para acompañar cualquier
            menú. Su sabor ligero y neutro se adapta perfectamente a cualquier plato, ya sea una ham-
            burguesa jugosa, una sopa caliente o una ensalada fresca.
            Además, nuestros Pan Buns son perfectos para aquellos que prefieren opciones de pan más
            suaves y menos densas. Cada bocado es una experiencia única, que se deshace en la boca y
            te deja con un delicioso sabor a pan fresco.
            Nuestro compromiso con la calidad significa que solo usamos los mejores ingredientes para
            hacer nuestros Pan Buns. Cada lote se hornea con cuidado para asegurar que cada pan esté
            perfectamente cocido y listo para ser disfrutado.
            Si estás buscando un pan versátil, suave y delicioso, nuestros Pan Buns son la elección
            perfecta. Haz que cada comida sea aún más deliciosa con nuestros deliciosos Pan Buns.
        `,
    },
    {
        name: "PAN DE VIENA",
        id:3,
        quantity: 0,
        price: 45,
        images: noimage,
        description: `
            ¡Bienvenido al delicioso mundo del pan de Viena elaborado con mantequilla y con una forma
            alargada y cortes en su corteza!
            Si eres un amante del pan, nuestro pan de Viena es una experiencia que no te puedes perder.
            Su miga suave y esponjosa, su corteza crujiente y sus cortes en forma de diamante que real-
            zan su belleza, hacen que sea el acompañante perfecto para cualquier comida.
            Nuestro pan de Viena es elaborado con mantequilla, lo que le da un sabor suave y cremoso
            que se funde en tu boca. Además, su forma alargada y sus cortes en la corteza, no solo le dan
            un aspecto visualmente atractivo, sino que también permiten que el pan se hornee de manera
            uniforme, obteniendo así una textura suave y esponjosa en todo el pan.
            En nuestra panadería, nos tomamos el tiempo para asegurarnos de que cada pan de Viena
            esté hecho con los mejores ingredientes y la técnica de horneado adecuada, lo que resulta en
            un sabor inigualable y una textura perfecta.
            Si buscas un pan de alta calidad para acompañar tus comidas, nuestro pan de Viena elabora-
            do con mantequilla y con forma alargada y cortes en su corteza es la elección perfecta.
            Prueba uno hoy y déjate seducir por su sabor y textura irresistibles.
        `,
    },
      {
        name: "PAN PERRO",
        id:4,
        quantity: 0,
        price: 45,
        images:imagePerro,
        description: `
            ¿Quieres experimentar el auténtico sabor de un hot dog? Entonces no busques más allá de
            nuestro pan perro pan típico para hot dog.
            Con su textura suave y esponjosa y su delicioso sabor, este pan es el complemento perfecto
            para cualquier hot dog. Hecho con ingredientes de la más alta calidad, cada bocado es una
            explosión de sabor que dejará a tus papilas gustativas pidiendo más.
            Ya sea que lo disfrutes con ketchup, mostaza, relish o cualquier otra combinación de condi-
            mentos, nuestro pan perro pan típico para hot dog es la opción perfecta para los amantes de
            los hot dogs en todo el mundo.
            Así que no esperes más para probar nuestro pan perro pan típico para hot dog y descubre por
            qué es la opción preferida de los conocedores de hot dogs en todo el mundo. ¡Ordénalo ahora
            y experimenta la diferencia!
        `,
    },
    {
        name: "PAN PERRO NEW YORK",
        id:5,
        quantity: 0,
        price: 45,
        images:imagePerroNY,
        description: `
        ¡El pan perro al estilo de Nueva York ha llegado a Cuba con un toque especial de ajonjolí!
        Imagínate disfrutando de un delicioso pan perro recién horneado, con un sabor auténtico y un
        toque de ajonjolí tostado en la parte superior. Este pan perro es la combinación perfecta de
        suave y esponjoso por dentro, y crujiente por fuera.
        La auténtica receta de pan perro estilo Nueva York, que ha sido llevada a Cuba, ahora se ha
        enriquecido con el sabor único del ajonjolí. Este ingrediente no solo aporta un toque extra de
        sabor, sino que también mejora la textura y el aspecto del pan.
        Este pan perro con ajonjolí es una deliciosa opción para cualquier ocasión. Ya sea que lo
        disfrutes solo con tus condimentos favoritos, o lo combines con ingredientes cubanos tradi-
        cionales como la carne de cerdo asada, esta versión del pan perro te sorprenderá con su
        sabor auténtico.
        En resumen, el pan perro estilo Nueva York con ajonjolí es una opción perfecta para aquellos
        que buscan un bocado sabroso y auténtico con un toque especial cubano. Prueba uno hoy y
        descubre por ti mismo la combinación perfecta de sabores. ¡No te arrepentirás!
        `,
    },*/
   
    {
        name: "NATURAL-PAN BARRA SUAVE ",
        id:6,
        quantity: 0,
        price: 150,
        images: noimage,
        description:`
                Si eres un amante del pan y te encanta probar nuevos sabores, ¡nuestro pan de barra suave
                saborizadas es perfecto para ti!
                Disponible en tres deliciosas opciones de sabor: natural, ajo y albahaca, nuestro pan de barra
                suave es el acompañamiento perfecto para cualquier comida. Elaborado con ingredientes de
                la más alta calidad, nuestro pan de barra suave saborizadas es suave y esponjoso, lo que lo
                hace ideal para sándwiches, tostadas y cualquier otra receta que se te ocurra.
                Si prefieres un sabor suave y neutro, nuestra opción natural es perfecta para ti. Pero si te
                encanta el ajo, ¡prueba nuestro pan de barra suave con sabor a ajo! El intenso sabor a ajo le
                da a este pan un toque único y delicioso. Y si prefieres sabores más frescos, nuestro pan de
                barra suave con sabor a albahaca te sorprenderá con su aroma y sabor.
                Ya sea que estés disfrutando de una cena en familia o de una reunión con amigos, nuestro
                pan de barra suave saborizadas es el acompañamiento perfecto. Además, ¡nuestro pan es
                muy versátil! Puedes utilizarlo para hacer deliciosos sándwiches, bruschettas, tostadas fran-
                cesas y mucho más.
                Prueba los tres sabores y descubre tu favorito. ¡No te arrepentirás de probar nuestro pan de
                barra suave saborizadas con ajo o albahaca!
            `,
    },
    {
        name: "AJO-PAN BARRA SUAVE ",
        id:7,
        quantity: 0,
        price: 150,
        images: noimage,
        description:`
                Si eres un amante del pan y te encanta probar nuevos sabores, ¡nuestro pan de barra suave
                saborizadas es perfecto para ti!
                Disponible en tres deliciosas opciones de sabor: natural, ajo y albahaca, nuestro pan de barra
                suave es el acompañamiento perfecto para cualquier comida. Elaborado con ingredientes de
                la más alta calidad, nuestro pan de barra suave saborizadas es suave y esponjoso, lo que lo
                hace ideal para sándwiches, tostadas y cualquier otra receta que se te ocurra.
                Si prefieres un sabor suave y neutro, nuestra opción natural es perfecta para ti. Pero si te
                encanta el ajo, ¡prueba nuestro pan de barra suave con sabor a ajo! El intenso sabor a ajo le
                da a este pan un toque único y delicioso. Y si prefieres sabores más frescos, nuestro pan de
                barra suave con sabor a albahaca te sorprenderá con su aroma y sabor.
                Ya sea que estés disfrutando de una cena en familia o de una reunión con amigos, nuestro
                pan de barra suave saborizadas es el acompañamiento perfecto. Además, ¡nuestro pan es
                muy versátil! Puedes utilizarlo para hacer deliciosos sándwiches, bruschettas, tostadas fran-
                cesas y mucho más.
                Prueba los tres sabores y descubre tu favorito. ¡No te arrepentirás de probar nuestro pan de
                barra suave saborizadas con ajo o albahaca!
            `,
    },
    {
        name: "ALBAHACA-PAN BARRA SUAVE ",
        id:8,
        quantity: 0,
        price: 150,
        images: noimage,
        description:`
                Si eres un amante del pan y te encanta probar nuevos sabores, ¡nuestro pan de barra suave
                saborizadas es perfecto para ti!
                Disponible en tres deliciosas opciones de sabor: natural, ajo y albahaca, nuestro pan de barra
                suave es el acompañamiento perfecto para cualquier comida. Elaborado con ingredientes de
                la más alta calidad, nuestro pan de barra suave saborizadas es suave y esponjoso, lo que lo
                hace ideal para sándwiches, tostadas y cualquier otra receta que se te ocurra.
                Si prefieres un sabor suave y neutro, nuestra opción natural es perfecta para ti. Pero si te
                encanta el ajo, ¡prueba nuestro pan de barra suave con sabor a ajo! El intenso sabor a ajo le
                da a este pan un toque único y delicioso. Y si prefieres sabores más frescos, nuestro pan de
                barra suave con sabor a albahaca te sorprenderá con su aroma y sabor.
                Ya sea que estés disfrutando de una cena en familia o de una reunión con amigos, nuestro
                pan de barra suave saborizadas es el acompañamiento perfecto. Además, ¡nuestro pan es
                muy versátil! Puedes utilizarlo para hacer deliciosos sándwiches, bruschettas, tostadas fran-
                cesas y mucho más.
                Prueba los tres sabores y descubre tu favorito. ¡No te arrepentirás de probar nuestro pan de
                barra suave saborizadas con ajo o albahaca!
            `,
    },
    {
        name: "BAGUETTE PRE-COCIDO",
        id:9,
        quantity: 0,
        price: 45,
        images: imageBaguette,
        description: `
                ¿Quieres disfrutar del delicioso sabor de una auténtica baguette francesa recién horneada en
                la comodidad de tu hogar? ¡Prueba nuestro pan baguette pre-cocido tradicional!
                Este pan baguette se distribuye congelado y pre-cocido para que puedas hornearlo en casa y
                disfrutar del aroma y sabor recién horneado que solo una auténtica baguette francesa puede
                ofrecer. Su textura crujiente y suave, su corteza dorada y su interior esponjoso te transporta-
                rán directamente a las calles de París.
                Elaborado con los mejores ingredientes y siguiendo una receta tradicional, nuestro pan
                baguette pre-cocido es la opción perfecta para aquellos que buscan un pan de alta calidad,
                sin conservantes ni aditivos artificiales. Además, su formato pre-cocido y congelado te
                permite tener siempre a mano una opción deliciosa y versátil para cualquier momento del día.
                Prueba nuestro pan baguette pre-cocido tradicional y descubre por qué es la elección perfec-
                ta para aquellos que buscan calidad, sabor y comodidad en un solo producto.
           `,
    },
    {
        name: "PAN PULLMAN TRADICIONAL MOLDE ENTERO",
        id:10,
        quantity: 0,
        price: 180,
        images: image14,
        description: `
                ¡Prueba nuestro delicioso pan de molde de corteza dorada y miga blanca, diseñado especial-
                mente para hacer los mejores sándwiches!
                Nuestro pan se elabora cuidadosamente en un sartén molde cuadrado con tapa, lo que le da
                su forma única y perfecta para preparar los sándwiches más sabrosos. Además, su corteza
                dorada le da un toque de crujiente extra, mientras que su miga blanca esponjosa se funde en
                la boca con cada bocado.
                ¿Te imaginas un sándwich hecho con nuestro pan de molde? ¡Te aseguramos que será una
                experiencia que nunca olvidarás! Es perfecto para cualquier combinación que se te ocurra,
                desde clásicos como jamón y queso, hasta opciones más creativas con aguacate, pollo a la
                parrilla o verduras asadas.
                No esperes más para probar el mejor pan de molde para tus sándwiches. ¡Haz de tus comi-
                das algo especial con nuestro pan de molde de corteza dorada y miga blanca!
            `,
    },
    {
        name: "BOLSA DE PAN BUNS",
        id:2,
        quantity: 0,
        price: 230,
        images: noimage,
        description: `
            ¡Prepárate para deleitar tus sentidos con nuestros deliciosos Pan Buns! Este pan redondo de
            masa suave es la adición perfecta para cualquier comida.
            Con su textura suave y esponjosa, nuestros Pan Buns son ideales para acompañar cualquier
            menú. Su sabor ligero y neutro se adapta perfectamente a cualquier plato, ya sea una ham-
            burguesa jugosa, una sopa caliente o una ensalada fresca.
            Además, nuestros Pan Buns son perfectos para aquellos que prefieren opciones de pan más
            suaves y menos densas. Cada bocado es una experiencia única, que se deshace en la boca y
            te deja con un delicioso sabor a pan fresco.
            Nuestro compromiso con la calidad significa que solo usamos los mejores ingredientes para
            hacer nuestros Pan Buns. Cada lote se hornea con cuidado para asegurar que cada pan esté
            perfectamente cocido y listo para ser disfrutado.
            Si estás buscando un pan versátil, suave y delicioso, nuestros Pan Buns son la elección
            perfecta. Haz que cada comida sea aún más deliciosa con nuestros deliciosos Pan Buns.
        `,
    },
    {
        name: "BOLSA DE BAGUETTE PRE-COCIDO",
        id:11,
        quantity: 0,
        price: 230,
        images: noimage,
        description: `
                
            `,
    },
    {
        name: "BOLSA DE HAMBURGUESA",
        id:16,
        quantity: 0,
        price: 230,
        images: noimage,
        description: `
                
            `,
    },
   
      {
        name: "BOLSA DE PERRO NATURAL",
        id:12,
        quantity: 0,
        price: 200,
        images: noimage,
        description: `
                
            `,
    },
    {
        name: "BOLSA DE PERRO NY",
        id:13,
        quantity: 0,
        price: 230,
        images: noimage,
        description: `
                
            `,
    },
    {
        name: "BOLSA DE VIENA",
        id:14,
        quantity: 0,
        price: 230,
        images: imageBolsaViena,
        description: `
                
            `,
    },
    {
        name: "HOGAZA",
        id:15,
        quantity: 0,
        price: 150,
        images: imageHogaza,
        description: `
                
            `,
    },
   
];
